// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RiKlE","footer":"styles_footer__2TRbG","passCodeTooltip":"styles_passCodeTooltip__21tst"};